import React from "react";

// The icon+label feature rows on a search result card (dates, room, flight, baggage, transfers, deposit).
export default function ResultFeatures({ result, format, isPerPerson, onShowCalendar, onShowFlight }) {
    return (
        <div className="space-y-2 mb-6">
            <div className="flex items-center gap-2 text-content_2 justify-between">
                <div className="flex items-center gap-2 text-content_2">
                    <svg width="24" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14 2V6M6 2V6M1 10H19M9.9955 14H10.0045M9.9955 18H10.0045M13.991 14H14M6 14H6.00897M6 18H6.00897M11 4H9C5.22876 4 3.34315 4 2.17157 5.17157C1 6.34315 1 8.22876 1 12V14C1 17.7712 1 19.6569 2.17157 20.8284C3.34315 22 5.22876 22 9 22H11C14.7712 22 16.6569 22 17.8284 20.8284C19 19.6569 19 17.7712 19 14V12C19 8.22876 19 6.34315 17.8284 5.17157C16.6569 4 14.7712 4 11 4Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="text-sm">
                        {result.startDateStr} - {result.duration} nights
                    </span>
                </div>
                <div>
                    <button
                        onClick={onShowCalendar}
                        className=" text-content_2 hover:text-content_3 ml-1 underline"
                    >
                        <div className="flex items-center gap-2 text-content_2">
                            <svg width="24" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14 2V6M6 2V6M1 10H19M9.9955 14H10.0045M9.9955 18H10.0045M13.991 14H14M6 14H6.00897M6 18H6.00897M11 4H9C5.22876 4 3.34315 4 2.17157 5.17157C1 6.34315 1 8.22876 1 12V14C1 17.7712 1 19.6569 2.17157 20.8284C3.34315 22 5.22876 22 9 22H11C14.7712 22 16.6569 22 17.8284 20.8284C19 19.6569 19 17.7712 19 14V12C19 8.22876 19 6.34315 17.8284 5.17157C16.6569 4 14.7712 4 11 4Z"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="text-sm">View Other dates</span>
                        </div>
                    </button>
                </div>
            </div>

            {/* Room Type */}
            <div className="flex items-center gap-2 text-content_2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 3.5V20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M22 8.5V20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 8.5L6 10.5H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 15.5H6M22 15.5H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M6 10.5V16.5C6 18.1547 6.34533 18.5 8 18.5H17C18.6547 18.5 19 18.1547 19 16.5V10.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.81362 10.5C6.89385 10.076 7.0202 9.63248 6.99567 9.19713C6.95941 8.5536 6.63697 7.96625 6.1264 7.61368C5.92478 7.47446 5.48 7.33239 5.01268 7.21093C4.3308 7.0337 3.98986 6.94508 3.59142 7.03644C3.30841 7.10133 3.06258 7.25187 2.71115 7.52079C2.67243 7.55042 2.65307 7.56523 2.62289 7.59026C2.3843 7.78812 2.17276 8.07424 2.05352 8.36034C2.03844 8.39653 2.02562 8.43102 2 8.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className="text-sm">{result.rooms[0].boardBasisName}</span>
            </div>

            {/* Flight Info */}
            <div className="flex items-center gap-2 text-content_2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.00031 20H18.0003M3.82527 12.1661C3.55027 11.9661 3.30027 11.7161 3.00028 10.8411C2.91891 10.6241 2.61139 9.53619 2.35028 8.54109C2.13003 7.7017 1.93377 6.93555 2.02528 6.74109C2.10029 6.54109 2.20027 6.39109 2.52527 6.19109C2.72527 6.06802 3.75027 5.81609 3.95027 5.76609C4.15027 5.71609 4.42526 5.69109 4.65027 5.76609C5.07527 5.84109 5.95027 7.11609 6.17527 7.26609C6.27526 7.36609 6.60027 7.657 6.97527 7.69109C7.25027 7.71609 7.52527 7.64109 7.82528 7.51609C8.10027 7.40151 13.5253 4.76609 14.0253 4.54109C18.1003 2.84109 21.0603 5.63609 21.5103 6.23609C21.9753 6.81609 22.0753 6.99109 21.9503 7.49109C21.7887 8.01609 21.3503 8.11609 21.1003 8.19109C20.8503 8.26609 17.4003 9.19109 16.0503 9.56609C15.7554 9.6621 15.6114 9.85492 15.5753 9.89109C15.4003 10.1411 14.6053 11.8411 14.3803 12.2161C14.2253 12.6161 13.8003 13.1161 13.2503 13.3161C12.6753 13.5161 11.6753 13.7411 11.4503 13.8161C11.2253 13.8911 10.7003 14.0411 10.5253 13.9911C10.3003 13.9411 10.0853 13.7161 10.1853 13.3661C10.2853 13.0161 10.4753 12.0411 10.5003 11.8911C10.5253 11.7411 10.7753 11.1161 10.5003 11.0911C10.4503 11.0161 9.92527 11.2411 9.15027 11.4161C8.57449 11.5782 7.9715 11.7386 7.55027 11.8411C5.92527 12.3161 5.04521 12.4411 4.85027 12.4411C4.47527 12.4411 4.20027 12.3911 3.82527 12.1661Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
                <div>
                    <span className="text-sm font-medium">
                        {result.flightOutbound.departureAirport.name} -{" "}
                        {result.flightOutbound.arrivalAirport.name}
                    </span>
                    <button
                        onClick={onShowFlight}
                        className="text-xs text-content_2 hover:text-content_3 ml-1 underline"
                    >
                        Flight details
                    </button>
                </div>
            </div>
            {result.includedBaggage > 0 && (
                <div className="flex items-center gap-2 text-content_2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15 6.5H9M15 6.5C17.8284 6.5 19.2426 6.5 20.1213 7.37868C21 8.25736 21 9.67157 21 12.5V15C21 17.8284 21 19.2426 20.1213 20.1213C19.2426 21 17.8284 21 15 21H9C6.17157 21 4.75736 21 3.87868 20.1213C3 19.2426 3 17.8284 3 15V12.5C3 9.67157 3 8.25736 3.87868 7.37868C4.75736 6.5 6.17157 6.5 9 6.5M15 6.5V6C15 4.58579 15 3.87868 14.5607 3.43934C14.1213 3 13.4142 3 12 3C10.5858 3 9.87868 3 9.43934 3.43934C9 3.87868 9 4.58579 9 6V6.5M7 6.5V21M17 6.5V21"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="text-sm">{result.includedBaggage}kg Baggage per person</span>
                </div>
            )}
            {result.includesTransfers && (
                <div className="flex items-center gap-2 text-content_2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 17V11.5C3 10.5 3.4 9.6 4.1 9L5.2 6.2C5.5 5.5 6.2 5 7 5H17C17.8 5 18.5 5.5 18.8 6.2L19.9 9C20.6 9.6 21 10.5 21 11.5V17M3 17H21M3 17V19.5C3 19.8 3.2 20 3.5 20H5.5C5.8 20 6 19.8 6 19.5V17M21 17V19.5C21 19.8 20.8 20 20.5 20H18.5C18.2 20 18 19.8 18 19.5V17M4.5 9.5H19.5"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M6.5 13.5H7.5M16.5 13.5H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="text-sm">Transfers included</span>
                </div>
            )}
            {result.deposit?.pricePP == 89 && (
                <div className="flex items-center gap-2 text-content_2">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21 8.5V3.42705C21 2.85889 20.6756 2.34452 20.1329 2.17632C19.1903 1.88421 17.4794 1.5 15 1.5C10.4209 1.5 9.1967 3.17747 2.87798 1.92361C1.92079 1.73366 1 2.44531 1 3.42116V13.4382C1 14.1265 1.47265 14.731 2.1448 14.8792C7.71199 16.1069 9.5572 15.1995 12.5 14.7859M1 5.5C2.95133 5.5 4.70483 3.90507 4.92901 2.25417M17.5005 2C17.5005 4.03964 19.2655 5.96899 21 5.96899M5.00049 14.9961C5.00049 12.787 3.20963 10.9961 1.00049 10.9961M15 13.5C15 12.9477 15.4477 12.5 16 12.5H21L19.5 10.5M21 15.5C21 16.0523 20.5523 16.5 20 16.5H15L16.5 18.5M13.4998 8.5C13.4998 9.8807 12.3805 11 10.9998 11C9.619 11 8.49976 9.8807 8.49976 8.5C8.49976 7.11929 9.619 6 10.9998 6C12.3805 6 13.4998 7.11929 13.4998 8.5Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="text-sm">
                        Low deposit{" "}
                        {format(result.deposit, { allowShortForm: true, removePostfix: true })}{" "}
                        {isPerPerson && <>per person</>}{" "}
                    </span>
                </div>
            )}
        </div>
    );
}
